/**
 * O que o service worker **nunca** pode tocar.
 *
 * Mora num módulo próprio porque é a regra mais perigosa do PWA e precisa
 * ser testável sem subir um service worker: a lista é importada pelo `sw.ts`
 * e pelo teste, então não existe a versão "do teste" e a versão "de
 * verdade".
 *
 * Cada entrada tem um motivo concreto:
 *
 * | Caminho       | Por que fica fora                                              |
 * | ------------- | -------------------------------------------------------------- |
 * | `/api/…`      | respostas do jogo mudam a cada segundo; servir uma do cache seria mostrar um painel velho ao operador |
 * | `/api/files/…`| foto de ganhador vem com URL **assinada e com validade** — cachear guardaria um link morto, e é dado pessoal |
 * | `/ws`         | WebSocket não passa por cache; interceptar só atrapalha o upgrade |
 * | `/healthz`    | sonda de saúde: resposta cacheada diria "vivo" com o servidor fora |
 * | `/telao`      | a TV tem de ser 100% rede (ver `sw.ts`)                          |
 */

export const SW_EXCLUDED_PATTERNS: RegExp[] = [
  /^\/api\//,
  /^\/api$/,
  /^\/ws(\/|$|\?)/,
  /^\/healthz$/,
  /^\/telao(\/|$|\?)/,
];

/** `true` = o service worker deve deixar passar direto para a rede. */
export function isExcludedFromSw(pathname: string): boolean {
  return SW_EXCLUDED_PATTERNS.some((pattern) => pattern.test(pathname));
}

/**
 * Esta página deve registrar o service worker?
 *
 * A TV não registra. É a exclusão de verdade do /telao: o escopo precisa ser
 * `/` por causa do /inicio e do /controle, e escopo não aceita exclusão —
 * então quem não registra é a própria página. Um aparelho que só abre
 * /telao, que é o caso da TV, nunca chega a ter service worker.
 */
export function shouldRegisterSw(pathname: string): boolean {
  return !pathname.startsWith('/telao');
}
